import * as THREE from 'three';

async function curtain() {
  const curtain = document.querySelector('.js-curtain');
  if (!curtain) return;

  const ua = navigator.userAgent || '';
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua) || matchMedia('(pointer: coarse)').matches;
  const isFirefox = /Firefox\//.test(ua);
  const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua);

  const canvas = curtain;
  const height = 200;

  //レンダラー
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: true,
  });
  const MAX_DPR = isFirefox || isSafari ? 1.0 : 2.0;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, MAX_DPR));

  //シーン
  const scene = new THREE.Scene();

  //カメラ
  const camera = new THREE.PerspectiveCamera(45, window.innerWidth / height, 1, 1000);
  camera.position.set(0, 0, 1);

  //本体
  let pageColor = new THREE.Color(0.082, 0.106, 0.11);
  const targetPage = document.querySelector('.p-home, .about, .business, .company');
  if (!targetPage) {
    pageColor = new THREE.Color(1, 1, 1);
  }

  const URL = document.body.dataset.url;
  const ROOT = `${URL}/public/shader`;
  const [vert, frag] = await Promise.all([fetch(`${ROOT}/curtain.vert`).then((res) => res.text()), fetch(`${ROOT}/curtain.frag`).then((res) => res.text())]);
  const uniforms = {
    uTime: { value: 0.0 },
    uColor: { value: pageColor },
  };

  const geo = new THREE.PlaneGeometry(2, 2);
  const material = new THREE.RawShaderMaterial({
    vertexShader: vert,
    fragmentShader: frag,
    transparent: true,
    uniforms,
  });
  const mesh = new THREE.Mesh(geo, material);
  scene.add(mesh);

  const clock = new THREE.Clock();
  const render = () => {
    material.uniforms.uTime.value = clock.getElapsedTime();
    renderer.render(scene, camera);
    requestAnimationFrame(render);
  };
  const resize = () => {
    const width = window.innerWidth;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height, false);
  };

  resize();
  render();

  let resizeFrame = 0;
  const onResize = () => {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = 0;
      resize();
    });
  };

  window.addEventListener('resize', onResize);
}

export { curtain };
